import { Stack, Typography } from "@mui/material";
import { isNil } from "lodash";

import { useRoleContext } from "hooks";
import { useIsMobile } from "hooks/useIsMobile";

import { CarrierQuoteDetail } from "./components/CarrierQuoteDetail";
import { QuoteQA } from "../../../QuoteQA";
import { MultiShipmentProjectQuoteDetail as ShipperMultiShipmentProjectQuoteDetail } from "../../../Shipper/components/MultiShipmentProjectQuoteDetail";
import { SingleShipmentQuoteDetail as ShipperSingleShipmentQuoteDetail } from "../../../Shipper/components/SingleShipmentQuoteDetail";

interface Props {
  quote: CondensedQuote | ShipperCondensedQuote;
}

export function QuoteDetail(props: Props) {
  const { quote } = props;
  const { role } = useRoleContext();
  const useColumnLayout = useIsMobile({ maxWidth: 900 });

  const isMultiShipmentProject = quote?.quote_type === "MULTI_SHIPMENT_PROJECT";

  let detailComponent = null;
  if (role?.type === "CARRIER") {
    detailComponent = <CarrierQuoteDetail quote={quote} />;
  } else if (role?.type === "SHIPPER") {
    const shipperQuote = quote as ShipperCondensedQuote;
    detailComponent = isMultiShipmentProject ? (
      <ShipperMultiShipmentProjectQuoteDetail quote={shipperQuote} />
    ) : (
      <ShipperSingleShipmentQuoteDetail quote={shipperQuote} />
    );
  }

  if (isNil(detailComponent)) {
    return <p>Something went wrong. Please contact us</p>;
  }

  if (useColumnLayout) {
    return (
      <Stack direction="column">
        {detailComponent}
        <Typography variant="h6" mt="1rem">
          Questions & Answers
        </Typography>
        <Stack
          id="quote-qa-container"
          pr="1rem"
          direction="column"
          flexWrap="wrap"
        >
          <QuoteQA quote={quote} />
        </Stack>
      </Stack>
    );
  }

  return (
    <Stack
      id="quote-detail-container"
      direction="row"
      mb="1rem"
      justifyContent="start"
      spacing={5}
    >
      <Stack width="60%">{detailComponent}</Stack>
      <Stack id="quote-qa-container" width="40%">
        <QuoteQA quote={quote} />
      </Stack>
    </Stack>
  );
}
